import DatePickerView from 'antd-mobile/lib/date-picker-view';
export default DatePickerView;



// WEBPACK FOOTER //
// ./components/date-picker-view/index.tsx